import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  CCreateElement,
  CSidebar,
  CSidebarBrand,
  CSidebarNav,
  CSidebarNavDivider,
  CSidebarNavTitle,
  CSidebarNavDropdown,
  CSidebarNavItem,
  CSidebarFooter,
} from '@coreui/react';

import { themeChangeSettings } from 'src/common/store/theme/actions';
import { getBackendVersion } from 'src/common/store/version/actions';

// sidebar nav config
import navigation from './_nav';
import { getFrontendVersion } from 'src/version';
import TextConstants from 'src/common/helpers/TextConstants';

const TheSidebar = () => {
  const dispatch = useDispatch();
  const show = useSelector((state) => state.Theme.sidebarShow);
  const { loading, backend } = useSelector((state) => state.Version);

  useEffect(() => {
    dispatch(getBackendVersion());
  }, [dispatch]);

  return (
    <CSidebar
      show={show}
      // onShowChange={(val) => dispatch({ type: 'set', sidebarShow: val })}
      onShowChange={(val) =>
        dispatch(themeChangeSettings({ sidebarShow: val }))
      }
    >
      <CSidebarBrand className="d-md-down-none" to="/">
        Chino Cloud
      </CSidebarBrand>
      <CSidebarNav>
        <CCreateElement
          items={navigation}
          components={{
            CSidebarNavDivider,
            CSidebarNavDropdown,
            CSidebarNavItem,
            CSidebarNavTitle,
          }}
        />
      </CSidebarNav>
      {/* <CSidebarMinimizer className="c-d-md-down-none" value={getVersion()}/> */}
      <CSidebarFooter className="text-center">
        <ul style={{ listStyleType: 'none' }}>
          <li style={{ textAlign: 'left' }}>
            {TextConstants.Common.FrontEnd}: v{getFrontendVersion()}
          </li>
          {!loading && (
            <li style={{ textAlign: 'left' }}>
              {TextConstants.Common.BackEnd}: v{backend.version}
            </li>
          )}
        </ul>
      </CSidebarFooter>
    </CSidebar>
  );
};

export default React.memo(TheSidebar);
